import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/logo.svg'


const _hoisted_1 = { class: "aside-logo" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    title: "IATSE Benefits Fund Logo"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "spotlight" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}